import Analytics from '@aws-amplify/analytics';

import setupPinPoint from 'helper/setupPinPoint';
import { getSuperProperties } from './utils/getSuperProperties';
import { getUser } from './utils/getUser';

setupPinPoint();

const reportRequest = (eventName, eventProperties, eventMetrics = {}) => {
  if (process.env.MY_ENV === 'production') {
    try {
      const attributes = {
        ...getUser(),
        ...getSuperProperties(),
        ...eventProperties
      };
      const recordObject = {
        name: eventName,
        attributes,
        metrics: {
          ...eventMetrics
        }
      };
      Analytics.record(recordObject);
    } catch (error) {
      console.log('error in pinpoint reporting is', error);
    }
  }
};

export default reportRequest;
